module.exports = __webpack_public_path__ + "img/soviet_boxers_280x280.9f0238d8.png";